import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateOpportunityRequest,
  UpdateOpportunityRequest,
} from '../../../models/opportunity.model';
import { opportunityService } from '../../../services/opportunityService';
import { OPPORTUNITIES_QUERY_KEY } from './useOpportunitiesQuery';
import { opportunityQueryKey } from './useOpportunityQuery';

export const useCreateOpportunity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateOpportunityRequest) => opportunityService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
    },
  });
};

export const useUpdateOpportunity = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateOpportunityRequest) => opportunityService.update(id, data),
    onSuccess: (updated) => {
      queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
      queryClient.setQueryData(opportunityQueryKey(id), updated);
    },
  });
};

export const useArchiveOpportunity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => opportunityService.archive(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: OPPORTUNITIES_QUERY_KEY });
      queryClient.removeQueries({ queryKey: opportunityQueryKey(id) });
    },
  });
};
